// extracted by mini-css-extract-plugin
module.exports = {"list":"_1pH0tY","list-item":"_1oaexB"};